/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IBodegasTiposPropiedades from 'Infotrack@Modelos/smartStock/bodegasTiposPropiedades/entidades/bodegasTiposPropiedades';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import BodegasTiposPropiedadesCM from '../controladorModelo/bodegasTiposPropiedadesCM';
import { acciones, IEstadoBodegasTiposPropiedades } from '../reductorBodegasTiposPropiedades';
import BodegasTiposPropiedadesVista from '../vista/tablaBodegasTiposPropiedadesVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const bodegasTiposPropiedadesCM = new BodegasTiposPropiedadesCM();

const TableBodegasTiposPropiedadesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [bodegasTiposPropiedadess, setBodegasTiposPropiedadess] = React.useState<IBodegasTiposPropiedades[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoBodegasTiposPropiedades>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarBodegasTiposPropiedades();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarBodegasTiposPropiedades = () => {
        manejadorIndicadorCargaGlobal(true);
        bodegasTiposPropiedadesCM
            .consultarFiltroBodegasTiposPropiedades({ EmpresaId: idEmpresa,Estado:-1 })
            .then((bodegasTiposPropiedadess) => {
                setBodegasTiposPropiedadess(bodegasTiposPropiedadess);
                manejadorIndicadorCargaGlobal(false);
            });
    };
    const manejarFormulario = (
        tipoFormulario: TipoFormulario,
        entidadBodegasTiposPropiedades?: IBodegasTiposPropiedades
    ) => {
        dispatch({
            type: acciones.CAMBIAR_ESTADO_FORMULARIO,
            payload: { entidadBodegasTiposPropiedades, tipoFormulario },
        });
    };

    const confirmarEliminacion = (bodegasTiposPropiedades: IBodegasTiposPropiedades) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarBodegasTiposPropiedades(bodegasTiposPropiedades),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarBodegasTiposPropiedades = (bodegasTiposPropiedades: IBodegasTiposPropiedades) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        bodegasTiposPropiedadesCM.eliminarBodegasTiposPropiedades(bodegasTiposPropiedades).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <BodegasTiposPropiedadesVista
            bodegasTiposPropiedadess={bodegasTiposPropiedadess}
            cargarBodegasTiposPropiedades={cargarBodegasTiposPropiedades}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableBodegasTiposPropiedadesCV;
